import { Tag as AntdTag } from "antd";
import React from "react";

export type MyTagProps = React.ComponentProps<typeof AntdTag>;

export interface TagStaticMethods {
  CheckableTag: typeof AntdTag.CheckableTag;
}

const Tag: React.FC<MyTagProps> & TagStaticMethods = (props) => {
  return <AntdTag {...props} />;
};

Tag.CheckableTag = AntdTag.CheckableTag;

export default Tag;
